// ============================================================================
// SQRT DECOMPOSITION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'sqrt-decomposition',
  name: 'Sqrt Decomposition',
  category: 'Data Structures',
  complexity: {
    time: 'O(√N) per query',
    space: 'O(N)'
  },
  description: 'A technique for answering range queries on arrays by dividing the array into blocks of size √N. Precomputes information for each block, enabling efficient range queries with O(√N) time complexity.'
};
